import { ServicesContainer } from '@/services';
import { ErrorEvent } from '@/services/analytics/events';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AnalyticsError, AnalyticsEventType, AnalyticsXDMEventType } from '../models';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeErrorEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.Error;
  eventType = AnalyticsXDMEventType.Error;
  error = { errors: { value: 1 } } as AnalyticsError;

  constructor(event: ErrorEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.error.errorName = event.midType ? event.errorName : `${event.errorType}|${event.errorName}`;
    this.web.webInteraction = this.extendObject(this.web.webInteraction, {
      linkModuleName: `${event.errorType}|${event.action}`,
      linkClicks: { value: 1 },
      type: 'other'
    });

    if (event.midType) {
      this.error.midType = event.midType;
    }

    if (event.errorType) {
      this.error.errorType = event.errorType;
    }

    if (store.state.adobe.latestWebPageDetails) {
      this.web.webPageDetails = this.extendObject(this.web.webPageDetails, {
        name: store.state.adobe.latestWebPageDetails.name
      })
    }
  }
}